// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoMetas_ExcluirInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /plano_metas/excluir
 *
 * Excludes a goals plan by ID.
 */
import { registerContract } from './validate'

export interface PlanoMetas_ExcluirInput {
id: number
}

registerContract('PlanoMetas_ExcluirInput', {
  id: { type: 'number',  required: true },
})
